module.exports = __webpack_public_path__ + "img/27600.f982626e.jpg";